module.exports = __webpack_public_path__ + "static/img/zeta_cr_template_01.ff69874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zeta_cr_template_01.png
// module id = 4rNV
// module chunks = 1